/**
 * "Uzavřené transakce" slideshows.
 *
 * Three independent Swiper fade carousels (see
 * template-parts/frontpage-closed-transactions.php), each with its own
 * autoplay delay read from `data-timing` (ms) — deliberately different per
 * instance so the section doesn't visually pulse in lockstep.
 *
 * Swiper is concatenated ahead of this file in the vendor/theme JS bundle
 * (see gulpfile.js VENDOR_JS), so `window.Swiper` is already defined and the
 * document already parsed by the time this runs — same reasoning as main.js
 * for skipping a DOMContentLoaded wrapper.
 */
( function () {
	'use strict';

	var DEFAULT_DELAY = 5000;

	function init( el ) {
		var delay = parseInt( el.getAttribute( 'data-timing' ), 10 );

		if ( ! delay || delay <= 0 ) {
			delay = DEFAULT_DELAY;
		}

		new window.Swiper( el, { // eslint-disable-line no-new
			effect: 'fade',
			fadeEffect: { crossFade: true },
			loop: true,
			autoplay: {
				delay: delay,
				disableOnInteraction: false
			}
		} );
	}

	if ( ! window.Swiper ) {
		return;
	}

	Array.prototype.forEach.call(
		document.querySelectorAll( '.closed-deals-swiper' ),
		init
	);
}() );
